export default {
	data: () => ({
		loading: false,
		lastRecord: {},
		limit: 10,
		page: 1,
		total: 0,
		list: [],
		columns: [
			{
				values: []
			},
			// 第二列
			{
				values: []
			},
			{
				values: []
			}
		],
		weekObj: {
			1: '第一周',
			2: '第二周',
			3: '第三周',
			4: '第四周',
			5: '第五周',
			6: '第六周'
		},
		datetimeType: 'date',
		currentDate: '',
		minDate: new Date(1970, 0, 1),
		maxDate: new Date(),
		showSelectDateTime: false,
		showSelectWeek: false,
		sunData: new Date()
	}),
	computed: {
		previewType() {
			return this.$route.query.previewType
		},
		patientId() {
			return this.$route.query.patientId || this.$store.getters['account/getPatientId']
		},
		finished() {
			return (this.page - 1) * this.limit >= this.total
		},
		dateDesc() {
			let str = ''
			if (this.dateType === 1) {
				str = this.$moment(this.sunData).format('YYYY-MM-DD')
			}
			if (this.dateType === 2) {
				str = `${this.$moment(this.sunData).startOf('isoWeek').format('YYYY.MM.DD')}-${this.$moment(
					this.sunData
				)
					.endOf('isoWeek')
					.format('YYYY.MM.DD')}`
			}
			if (this.dateType === 3) {
				str = this.$moment(this.sunData).format('YYYY-MM')
			}
			return str
		}
	},
	watch: {
		dateType() {
			this.getDetail()
		}
	},
	async mounted() {
		window.scrollTo(0, 0)
		this.init()
		await this.load()
	},
	methods: {
		async clickCreate() {
			// 血压记录
			// if (this.$route.name === 'IndicatorBloodPressure') {
			// 	if (this.list.length) {
			// 		//按照创建时间排序
			// 		let list = this.list.sort(function (a, b) {
			// 			return b.gmtCreate < a.gmtCreate ? -1 : 1
			// 		})
			// 		this.editUrl += `?strokeType=${list[0].strokeType}`
			// 	}
			// }
			// 血糖记录
			if (this.$route.name === 'IndicatorBloodSugar') {
				if (this.list.length) {
					this.editUrl += `?isDiabetes=${this.list[0].isDiabetes}`
				}
			}
			await this.$router.push(this.editUrl)
		},
		async clickEdit(val) {
			await this.$router.push(`${this.editUrl}/${val.id}`)
		},
		init() {
			let years = []
			for (let i = 2010; i < 2025; i++) {
				years.push({
					type: 'year',
					value: i
				})
			}
			this.columns[0].values = years
			let months = []
			for (let i = 1; i < 13; i++) {
				months.push({
					type: 'month',
					value: i > 9 ? i : '0' + i
				})
			}
			this.columns[1].values = months
		},
		onChange(picker, values, index) {
			console.log(picker, values, index)
			if ([0, 1].indexOf(index) > -1) {
				let arr = []
				let year = values[0].value
				let month = values[1].value
				let firstDay = `${year}-${month}-01`
				let startDay = this.$moment(firstDay).startOf('isoWeek').format('YYYY-MM-DD')
				let monthLastDay = this.$moment(firstDay).endOf('month').format('YYYY-MM-DD')
				this.formatWeek(arr, startDay, monthLastDay)
				picker.setColumnValues(2, arr)
			}
		},
		/**
		 * 选择时间 或 日期
		 */
		selectTime() {
			if ([1, 3].indexOf(this.dateType) > -1) {
				this.showSelectDateTime = true
				this.datetimeType = this.dateType === 1 ? 'date' : 'year-month'
				this.currentDate = new Date(this.$moment(this.sunData))
			}
			if (this.dateType === 2) {
				// 判断年份默认值
				let year = this.$moment(this.sunData).year()
				let month = this.$moment(this.sunData).month() + 1
				month = month > 9 ? month : '0' + month
				this.columns[0].defaultIndex = this.columns[0].values.findIndex(v => v.value === year)
				this.columns[1].defaultIndex = this.columns[1].values.findIndex(v => v.value === month)

				// 初始化周
				let weeks = []
				let firstDay = `${year}-${month}-01`
				let startDay = this.$moment(firstDay).startOf('isoWeek').format('YYYY-MM-DD')
				let nowWeekDay = this.$moment(this.sunData).startOf('isoWeek').format('YYYY-MM-DD')
				let monthLastDay = this.$moment(firstDay).endOf('month').format('YYYY-MM-DD')
				this.formatWeek(weeks, startDay, monthLastDay)

				this.showSelectWeek = true
				let yearIndex = this.columns[0].values.findIndex(v => v.value === year)
				let monthIndex = this.columns[1].values.findIndex(v => v.value === month)
				let weekIndex = weeks.findIndex(v => v.value === nowWeekDay)
				this.$nextTick(() => {
					this.$refs.picker.setColumnValues(2, weeks)
					this.$refs.picker.setIndexes([yearIndex, monthIndex, weekIndex])
				})
			}
		},
		confirmTime(val) {
			if (this.dateType === 2) {
				this.sunData = this.$moment(val[2].value).format('YYYY-MM-DD')
				this.getDetail()
				this.showSelectDateTime = false
				this.showSelectWeek = false
			} else {
				this.sunData = this.$moment(val).format('YYYY-MM-DD')
				this.showSelectDateTime = false
				this.showSelectWeek = false
				this.getDetail()
			}
		},
		formatWeek(arr, startDay, endDay) {
			let slft = this
			function format(arr, startDay, endDay) {
				let day = slft.$moment(startDay).add(arr.length, 'W').format('YYYY-MM-DD')
				if (endDay >= day) {
					arr.push({
						type: 'week',
						value: day,
						number: arr.length + 1
					})
					format(arr, startDay, endDay)
				}
			}
			format(arr, startDay, endDay)
		},
		initList(old, list) {
			let oldArray = JSON.parse(JSON.stringify(old))
			list.map(v => {
				let date = this.$moment(v.measureTime).format('YYYY-MM-DD')
				let index = oldArray.findIndex(r => r.date === date)
				if (index > -1) {
					oldArray[index].list.push(v)
				} else {
					oldArray.push({
						date,
						list: [v]
					})
				}
			})
			return oldArray
		}
	}
}
